import useLanguage from '@op/hooks/useLanguage';
import { DBO_TM } from '@op/utils/format';
import React from 'react';
import { Button, H6, Modal } from 'tea-component';

export default function TimingModal({
  onClose,
  onClick,
  filter,
  visible,
}: {
  onClose?: any;
  onClick?: any;
  filter?: any;
  visible: boolean;
}) {
  const { formatMessage } = useLanguage();
  return (
    <Modal
      disableEscape
      visible={visible}
      caption={formatMessage({ id: 'Generate Analysis' })}
      onClose={() => onClose?.()}
    >
      <Modal.Body>
        {formatMessage(
          {
            id: 'Analysis will cover comments from {date}. Please  verify whether this period includes the original post publication date.',
          },
          {
            date: (
              <H6 style={{ display: 'inline', fontSize: '14px' }}>
                {DBO_TM.timeTitle({ ...filter, link_text: ' ~ ' })}
              </H6>
            ),
          },
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={() => onClick?.()}>
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button onClick={() => onClose?.()}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
